@if (isLoading | async) {
  <div class="loader">
    <div class="loader-container">
      <img class="fa-spin loader-container-logo" src="/assets/imgs/sircles-pic.svg" alt="Loading" />
    </div>
  </div>
}
